/**
 * Разрешения для медиа запросов в css - Desktop first
 *
 * @name data.breakPoints
 * @type {Record<String string>}
 */
export const breakPoints = {
    desktop: '1600px',
    sDesktop: '1365px',
    tablet: '1023px',
    mobile: '767px',
    sMobile: '375px',
};

/**
 * Разрешения для медиа запросов в css - Mobile First
 *
 * @name data.BreakPointsMFirst
 * @type {Record<String string>}
 */
export const BreakPointsMFirst = {
    desktop: '1601px',
    sDesktop: '1366px',
    tablet: '1024px',
    mobile: '768px',
};
